export default __webpack_public_path__ + "static/fcq-case-study-33b5784a4f7b38298c85bfce02ac36ed.webp";